import { createFileRoute } from "@tanstack/react-router";
import { MexicoDominationScore } from "@/components/admin/MexicoDominationScore";
import { MexicoStateLeaderboard } from "@/components/growth/MexicoStateLeaderboard";
import { MexicoRivalryCards } from "@/components/growth/MexicoRivalryCards";
import { MexicoHallOfFame } from "@/components/growth/MexicoHallOfFame";
import { MexicoShareCenter } from "@/components/growth/MexicoShareCenter";
import { MexicoCommunityFeed } from "@/components/growth/MexicoCommunityFeed";

export const Route = createFileRoute("/admin/mexico-domination")({
  head: () => ({
    meta: [
      { title: "México Domination Score — VerseSport Admin" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: MexicoDominationPage,
});

function MexicoDominationPage() {
  return (
    <main className="mx-auto max-w-3xl space-y-3 px-3 py-4">
      <header>
        <h1 className="text-xl font-black">🇲🇽 México Command Center</h1>
        <p className="text-[12px] text-muted-foreground">
          Panel ejecutivo de la operación México — retención, compartidos, referidos,
          conversiones, creadores y afición por estado.
        </p>
      </header>
      <MexicoDominationScore />
      <section aria-label="Paneles MX" className="grid grid-cols-1 gap-3 lg:grid-cols-2">
        <div><MexicoStateLeaderboard /></div>
        <div><MexicoRivalryCards /></div>
        <div><MexicoHallOfFame /></div>
        <div><MexicoShareCenter /></div>
        <div className="lg:col-span-2"><MexicoCommunityFeed /></div>
      </section>
      <p className="text-[10px] text-muted-foreground">
        MX-01 Growth · MX-02 Acquisition · MX-03 Viral · MX-04 Influencers · MX-05 States ·
        MX-06 Community · MX-07 Retention · MX-08 Conversion · MX-09 Nation Impact · MX-10 Executive.
      </p>
    </main>
  );
}